import makeActionCreator from 'src/lib/makeActionCreator';

export const SET_ALERT = 'SET_ALERT';
export const RESET_ALERT = 'RESET_ALERT';

export const setAlert = makeActionCreator(SET_ALERT);
export const resetAlert = makeActionCreator(RESET_ALERT);
